import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const MediaPrint = ({ data }) => {
    const { t } = useTranslation();

    // Same extra saved delivery info (e.g. selected store, courier/pickup details) shown on the
    // on-screen order info block - that block is hidden on print (see .orderInfo in
    // OrdersDetailsPage.module.scss), so it needs to be duplicated here too.
    const deliveryAdditionalText = data?.deliveries?.[0]?.format_data?.partial?.additional
        ?.map((row) => row.text)
        .filter(Boolean)
        .join(", ");

    const convertDate = (date) => {
        const options = {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: false,
        };

        const dateObj = new Date(date);
        const formattedDate = dateObj
            .toLocaleString("sr-RS", options)
            .replace(/,/g, "")
            .replace(/(\d+)\D+(\d+)\D+(\d+)\D+(\d+):(\d+)/, "$1.$2.$3. $4:$5");
        return formattedDate;
    };
    return (
        <>
            <Box
                sx={{
                    display: "none",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "1rem",
                    "@media print": {
                        display: "grid",
                        order: "-1 !important",
                        marginBottom: "2rem",
                    },
                }}
            >
                <Box>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-order")}:</span>
                        {data?.order?.slug}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-order_date")}:</span>
                        {convertDate(data?.order?.created_at)}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-company_name")}:</span>
                        {data?.billing_address?.company_name}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-company_address")}:</span>
                        {data?.billing_address?.address}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-city")}:</span>
                        {data?.billing_address?.town_name}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-postal_code")}:</span>
                        {data?.billing_address?.zip_code}
                    </p>
                </Box>
                <Box>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-country")}:</span>
                        {data?.billing_address?.country_name}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-PIB")}:</span>
                        {data?.billing_address?.pib}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-social_security_number")}:</span>
                        {data?.billing_address?.maticni_broj}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-ordered_the_goods")}:</span>
                        {data?.billing_address?.first_name + " " + data?.billing_address?.last_name}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-method_payment")}:</span>
                        {data?.order?.payment_method_name}
                    </p>
                    <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                        <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-delivery_method")}:</span>
                        {data?.order?.delivery_method_name}
                    </p>
                    {deliveryAdditionalText && (
                        <p style={{ fontSize: "0.8rem", marginBottom: "0.2rem" }}>
                            <span style={{ marginRight: "0.3rem", fontWeight: "700" }}>{t("order_details-media_print-text-delivery_additional_info")}:</span>
                            {deliveryAdditionalText}
                        </p>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default MediaPrint;
